var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "cell padding-bottom-1" }, [
    _c("article", { staticClass: "pega-information-container" }, [
      _c("div", { staticClass: "pega-information-content" }, [
        _c(
          "ul",
          { staticClass: "pega-information-content-ul" },
          _vm._l(_vm.informations, function (information, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass: "pega-information-content-li",
                attrs: { "data-test": "information-modal-title-li-" + index },
              },
              [
                _c(
                  "a",
                  {
                    attrs: { "data-test": "information-modal-title-" + index },
                    on: {
                      click: function ($event) {
                        return _vm.openInformationModal(index)
                      },
                    },
                  },
                  [_vm._v(_vm._s(information.title))]
                ),
                _vm._v(
                  _vm._s(_vm._f("formatDate")(information.createDate)) +
                    "\n        "
                ),
              ]
            )
          }),
          0
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "reveal boss-modal-container pega-modal-position pega-information-modal-layout",
        attrs: { id: "information-modal", "data-reveal": "" },
      },
      [
        _c(
          "h1",
          {
            staticClass:
              "boss-page-title boss-page-title-layout-title font-bold padding-right-2",
            attrs: { "data-test": "modal-title" },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.informations[_vm.openInformationModalIndex].title) +
                "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "pega-information-modal-body",
          attrs: { "data-test": "modal-body" },
          domProps: { innerHTML: _vm._s(_vm.renderBody) },
        }),
        _vm._v(" "),
        _vm.informations[_vm.openInformationModalIndex].files.length
          ? _c(
              "div",
              {
                staticClass: "margin-top-1",
                attrs: { "data-test": "information-files" },
              },
              _vm._l(
                _vm.informations[_vm.openInformationModalIndex].files,
                function (file, index) {
                  return _c(
                    "a",
                    {
                      key: index,
                      staticClass: "display-block",
                      attrs: { "data-test": "modal-file-" + index },
                      on: {
                        click: function ($event) {
                          return _vm.download(file.id, file.name)
                        },
                      },
                    },
                    [_vm._v("\n        " + _vm._s(file.name) + "\n      ")]
                  )
                }
              ),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _c("button", {
          staticClass: "close-button boss-close-button boss-icon-cross",
          attrs: {
            "data-test": "modal-close",
            "data-close": "",
            "aria-label": "Close modal",
            type: "button",
          },
          on: {
            click: function ($event) {
              return _vm.closeReveal()
            },
          },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }